import saudicupApi from "@/api/saudicupApi";
import authHeader from "@/services/saudi-cup/auth/auth-header";
class AirlineService {
    send_request(body) {
        return saudicupApi.post(
            '/api/airline/need-help-flight', body, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
    send_self_paying_request(body) {
        return saudicupApi.post(
            '/api/airline/self_paying_airline', body, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
}
export default new AirlineService();